<div
  [ngClass]="[
    'wrap',
    book === 'tokyo-metro' ? 'wrap-metro' : '',
    book === 'lets-make-metro' ? 'wrap-lets-make' : '',
    book === 'this-is-my-dream-line' ? 'wrap-timdl' : ''
  ]"
>
  <div class="wrap__container">
    <div class="container">
      <div class="container__text">
        <p
          class="text"
          [ngStyle]="{ color: 'white' }"
          *ngIf="book === 'tokyo-metro'"
        >
          じめんのした、とっても　ふかいところを、たくさんの　おきゃくさんをのせて　すすむんだ。
        </p>
        <p
          class="text"
          [ngStyle]="{ color: '$c-default' }"
          *ngIf="book === 'lets-make-metro'"
        >
          いまから　１００ねんいじょう　むかしのこと<br />そのころには　まだ　ちかてつは　ありませんでした……。
        </p>
        <p
          class="text"
          [ngStyle]="{ color: 'white' }"
          *ngIf="book === 'this-is-my-dream-line'"
        >
          どんなみちを　えらんでも
          <br />あなたが　だいすきなことを　たいせつにしてね
        </p>
      </div>
    </div>
  </div>
</div>
